import {useQuery} from '@tanstack/react-query';
import {getUserHints} from '../../../utils/DirectoryAPI';
import {receiveUserHints} from '../../../redux/actions/UserActions';
import {useDispatch} from 'react-redux';

export const useGetUserHintsQuery = (userId) => {
    const dispatch = useDispatch();
    return useQuery({
        enabled: !!userId,
        queryKey: ['get-user-hints', userId],
        queryFn: (context) => getUserHints(context[1]),
        onSuccess: (data) => {
            dispatch(receiveUserHints(data));
        },
    });
};
